import { render, staticRenderFns } from "./ProductCover.vue?vue&type=template&id=62e68ac2&scoped=true&"
import script from "./ProductCover.vue?vue&type=script&lang=js&"
export * from "./ProductCover.vue?vue&type=script&lang=js&"
import style0 from "./ProductCover.vue?vue&type=style&index=0&id=62e68ac2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e68ac2",
  null
  
)

export default component.exports